import React from 'react';
import {
  getReglementPointageContext,
  type ReglementPointageContextType,
} from '@/contexts/ReglementPointageContext';
import type { ModeReglementsPointageType } from '@/types';

const EMPTY_CONTEXT: ReglementPointageContextType = {
  total: 0,
  reglements: [],
  sorts: {},
  loading: false,
  setReglements: () => {},
  setSorts: () => {},
  setPage: () => {},
  setTotal: () => {},
  reset: () => {},
};

const useReglementPointage = (code: ModeReglementsPointageType) => {
  const SpecificContext = getReglementPointageContext(code);
  const context = React.useContext(SpecificContext);

  // Si le contexte n'existe pas, retourner un objet vide
  if (!context) {
    return EMPTY_CONTEXT;
  }

  return context;
};

export default useReglementPointage;
